// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".totp-qrcode .qrcode-tip[data-v-1e7e71d0] {\n  margin-top: 8px;\n  color: #666;\n  font-size: 12px;\n  text-align: left;\n}\n.totp-qrcode .qrcode-tip .anticon[data-v-1e7e71d0] {\n  margin-right: 4px;\n  color: #1890ff;\n}\n.totp-qrcode .secret-display[data-v-1e7e71d0] {\n  margin-top: 8px;\n  padding: 8px;\n  background: #f5f5f5;\n  border-radius: 4px;\n  text-align: center;\n  font-family: monospace;\n}\n", ""]);
// Exports
module.exports = exports;
